import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const ActionButton = styled(Button)`
  padding: 8px 16px;
  height: 100%;
  border-radius: 8px;
  ${({ theme }) => theme.typography.body2.b};
  color: ${({ theme }) => theme.colors.text.high.white};
  box-shadow: none;
  &:hover {
    box-shadow: none;
  }
`;
